export function FourZeroFour() {
  return (
    <div>
      <h2>Oops, this page doesn't exist.</h2>
    </div>
  );
}
